module.exports = __webpack_public_path__ + "static/media/transport.3f836c9d.svg";